export const topics = [
  {
    id: "topliu-shanye-shanwen",
    title: "顶流深夜发文又秒删，工作室凌晨回应引热议",
    category: "ent",
    categoryName: "娱乐圈",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20stage%20spotlights%20in%20a%20dark%20theater%20with%20distant%20paparazzi%20camera%20flashes%2C%20moody%20late%20night%20editorial%20photograph%2C%20warm%20amber%20and%20coral%20neon%20glow%2C%20cinematic%20atmosphere%2C%20subtle%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-01&orientation=landscape",
    summary:
      "凌晨一点二十分，某位长期霸榜的顶流艺人发了一条意味深长的动态，两分钟后删除。工作室在凌晨三点发布声明，评论区瞬间涌入上万条猜测。",
    tags: ["顶流", "秒删", "工作室回应", "深夜动态"],
    heat: 98600,
    views: 45200,
    comments: 1284,
    author: "瓜田管理员",
    time: "2小时前",
    content: [
      "事情发生在凌晨一点二十分。一条仅有七个字的动态出现在某位顶流艺人的个人主页上，措辞暧昧、没有配图，两分钟后被删除。截图在删除后的十分钟内扩散到各大讨论群，成为当晚第一个爆点。",
      "凌晨三点，艺人工作室发布了一份篇幅不长的声明，表示「相关动态为误操作，感谢大家关心，后续以官方信息为准」。这份声明既没有解释七个字的具体含义，也没有回应网友最关心的那个问题，反而让讨论热度再次攀升。",
      "目前主要存在三种猜测：一是纯属手滑误发，二是为新作品预热，三是与近期网传的合作变动有关。三种说法都没有实锤，但每一种都有人在评论区列出了自己的「证据链」。",
      "值得注意的是，这位艺人过去一年极少在深夜发文，这次的时间点和删除速度，恰好成了大家判断「是否有意为之」的关键。",
    ],
    points: [
      "动态存在时长仅约两分钟，截图扩散速度远超删除速度",
      "工作室声明回避了核心问题，仅以「误操作」带过",
      "近一年深夜发文频率极低，时间点成为讨论焦点",
    ],
  },
  {
    id: "guzhuang-huanjiao-fengbo",
    title: "古装大剧换角风波：原定男主为何突然退出",
    category: "drama",
    categoryName: "影视剧综",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20corridor%20at%20night%20lit%20by%20warm%20hanging%20lanterns%2C%20cinematic%20moody%20atmosphere%2C%20deep%20shadows%2C%20coral%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-02&orientation=landscape",
    summary:
      "开拍前三周，这部备受期待的古装大剧突然官宣更换男主角。官方说法是「档期调整」，但多个信源的说法并不一致。",
    tags: ["换角", "古装剧", "档期", "开机"],
    heat: 87400,
    views: 38900,
    comments: 976,
    author: "追剧小分队",
    time: "5小时前",
    content: [
      "这部古装剧从立项起就备受关注，原著粉丝基数大，导演此前有口碑作品，选角公布时一度登上热搜。然而就在离开机还有三周的时候，剧组突然发布公告，宣布男主角因「档期调整」不再出演。",
      "公告发出后，先后出现了至少三种说法：一是演员方主动退出，二是剧组在剧本方向上与演员团队未能达成一致，三是平台方对整体阵容提出了新的要求。三种说法目前均未获得官方证实。",
      "有意思的是，原定男主在公告发布前一天还更新了与该剧相关的训练动态，这让「档期」的说法显得有些站不住脚。评论区里，粉丝和路人的判断几乎是完全对立的。",
      "目前接替人选尚未公布，剧组表示会「尽快给出让观众满意的答案」。",
    ],
    points: [
      "公告发布前一天演员仍在更新剧组相关训练动态",
      "官方口径为「档期调整」，但外界流传至少三种版本",
      "接替人选未定，播出档期是否顺延仍是未知数",
    ],
  },
  {
    id: "lianzong-jiabin-xueli",
    title: "恋综素人嘉宾被扒学历存疑，节目组迟迟未回应",
    category: "variety",
    categoryName: "综艺现场",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20reality%20show%20set%20with%20soft%20warm%20studio%20lights%20and%20two%20vacant%20stools%2C%20dark%20moody%20interior%2C%20amber%20glow%2C%20cinematic%20photograph%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-03&orientation=landscape",
    summary:
      "一档恋爱观察综艺播出两期后，其中一位素人嘉宾的公开资料被网友逐条比对，学历与工作经历出现多处对不上的地方。",
    tags: ["恋综", "素人嘉宾", "人设", "节目组"],
    heat: 76300,
    views: 33400,
    comments: 842,
    author: "综艺观察员",
    time: "8小时前",
    content: [
      "这类恋爱综艺的看点之一，就是素人嘉宾的「真实感」。但节目播出两期后，有网友开始整理其中一位嘉宾的自我介绍，发现学校名称、毕业年份与公开可查的信息存在出入。",
      "更受关注的是工作经历部分。节目里提到的职位与行业，和该嘉宾社交平台上长期发布的内容风格并不一致，这让一部分观众产生了「人设包装」的怀疑。",
      "截至目前，节目组与嘉宾本人都没有就此事作出回应。按照同类节目的惯例，通常会在争议发酵到一定程度后才统一说明，但这种沉默本身也被解读成了另一种信号。",
      "讨论区的分歧很明显：一部分人认为素人不是公众人物，不必过度审视；另一部分人则觉得，既然享受了节目带来的曝光与商业机会，就应该接受基本的真实性监督。",
    ],
    points: [
      "公开资料与节目自我介绍存在多处出入",
      "节目组与嘉宾均未回应，沉默被多方解读",
      "「素人是否该被审视」成为评论区核心分歧",
    ],
  },
  {
    id: "daidai-zhubo-fanche",
    title: "带货主播直播间翻车，两千名粉丝集体要求退款",
    category: "live",
    categoryName: "网红直播",
    cover:
      "https://readdy.ai/api/search-image?query=ring%20light%20and%20studio%20microphone%20on%20a%20dark%20live%20streaming%20desk%2C%20warm%20amber%20rim%20glow%2C%20moody%20night%20atmosphere%2C%20cinematic%20product%20photography%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-04&orientation=landscape",
    summary:
      "一场持续六小时的带货直播结束后，关于商品规格与宣传不符的投诉集中爆发，退款申请在短时间内累积超过两千条。",
    tags: ["直播带货", "退款", "售后", "翻车"],
    heat: 82100,
    views: 35600,
    comments: 913,
    author: "剁手监察组",
    time: "11小时前",
    content: [
      "这场直播从晚上八点持续到凌晨两点，主推的几款商品在讲解中被反复强调「同款同规格」「专柜同源」。直播结束后的第二天上午，第一批收到货的用户开始在评论区晒出对比图。",
      "争议主要集中在两点：一是实际收到的商品在容量与材质上与讲解描述存在差距；二是部分商品的外包装缺少直播间承诺的赠品。随着晒图增多，退款申请在半天内累积超过两千条。",
      "主播团队在下午发布了一条说明，表示「部分批次存在包装差异，不影响使用」，并给出两种处理方案。但这个回应并没有平息争议，反而因为「不影响使用」这一表述，被认为是在回避规格差异的核心问题。",
      "目前平台客服已经介入。对围观者来说，这场风波更像是关于「直播间话术边界」的一次集中讨论，而不只是单一商品的问题。",
    ],
    points: [
      "争议集中在容量材质与赠品缺失两点",
      "官方回应「不影响使用」被认为回避核心问题",
      "退款申请半天内累积超过两千条",
    ],
  },
  {
    id: "yinyuejie-yazhou-chidao",
    title: "音乐节压轴歌手迟到四十分钟，主办方连夜致歉",
    category: "music",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=night%20outdoor%20music%20festival%20stage%20with%20warm%20crowd%20lights%20and%20drifting%20haze%2C%20silhouette%20of%20speakers%2C%20cinematic%20moody%20atmosphere%2C%20amber%20and%20coral%20glow%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-05&orientation=landscape",
    summary:
      "本该十点登场的压轴歌手，直到十点四十才出现在舞台上。等待期间，部分观众开始离场，现场气氛一度变得微妙。",
    tags: ["音乐节", "压轴", "迟到", "主办方"],
    heat: 71500,
    views: 29800,
    comments: 734,
    author: "现场记录者",
    time: "14小时前",
    content: [
      "这是一场持续两天的户外音乐节，压轴时段安排在晚上十点。然而十点整舞台并没有亮起，大屏幕上只是循环播放着赞助商画面。十分钟、二十分钟过去，前排观众的情绪开始出现波动。",
      "十点四十分，歌手终于登台。他解释说是因为设备调试出现问题，并临时调整了歌单作为补偿。尽管如此，仍有不少观众在社交平台上表达了不满，理由是「前面几个乐队的换场都很准时」。",
      "主办方在演出结束两小时后发布致歉声明，承诺为当晚购票观众提供一场福利演出作为补偿。这份处理速度算是比较快的，但对已经离场的那部分观众来说，损失的时间无法找回。",
      "现场观众的一个细节值得玩味：当歌手终于开唱时，全场几乎是瞬间大合唱，刚才的抱怨好像被暂时收了起来。",
    ],
    points: [
      "迟到约四十分钟，原因指向设备调试",
      "临时调整歌单作为现场补偿",
      "主办方两小时内致歉并承诺福利场",
    ],
  },
  {
    id: "dianjing-caifang-yanlun",
    title: "电竞选手赛后采访言论惹争议，赛训团队紧急沟通",
    category: "esports",
    categoryName: "体育电竞",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20esports%20arena%20with%20glowing%20screens%20and%20warm%20red%20stage%20lighting%2C%20empty%20gaming%20chairs%2C%20cinematic%20moody%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-06&orientation=landscape",
    summary:
      "一场关键比赛失利后，选手在采访中直接点名队友的表现。这段三十秒的视频在两个小时内播放量破百万。",
    tags: ["电竞赛事", "选手采访", "团队沟通", "争议发言"],
    heat: 68900,
    views: 27600,
    comments: 688,
    author: "赛场显微镜",
    time: "17小时前",
    content: [
      "这类赛后采访通常会以「我们整体发挥不好」收尾，但这次没有。这位选手在被问到失利原因时，直接把问题指向了团队在关键团战中的决策，并点名了具体位置。",
      "采访视频发布后的两个小时内播放量破百万。支持者认为他「敢说真话」，是职业素养的体现；反对者则认为，公开场合点名队友，对团队氛围的伤害远大于表达价值。",
      "俱乐部在当晚发布了一份简短说明，表示「队内已经充分沟通，专注接下来的比赛」。没有道歉，也没有处罚，这种处理方式在小圈子里又引发了新一轮讨论。",
      "抛开立场，这次争议其实暴露了一个更普遍的问题：在镜头越来越近的电竞行业里，选手的「真实表达」和「公共责任」之间，到底应该怎么划线。",
    ],
    points: [
      "采访中直接点名队友表现，罕见但并非首次",
      "俱乐部回应「已充分沟通」，未给出进一步处理",
      "引发「真实表达 vs 公共责任」的行业讨论",
    ],
  },
  {
    id: "zhedie-ping-liangchan",
    title: "新款折叠屏被曝量产问题，官方深夜发布说明",
    category: "tech",
    categoryName: "数码科技",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20foldable%20smartphone%20lying%20on%20a%20dark%20textured%20desk%20with%20warm%20rim%20lighting%2C%20minimal%20product%20photography%2C%20moody%20night%20atmosphere%2C%20amber%20highlight%2C%20high%20detail&width=1200&height=800&seq=yc-topic-07&orientation=landscape",
    summary:
      "距离正式开售还有一周，多位提前拿到工程机的数码博主发现，折叠铰链在低温环境下开合阻力明显增大。",
    tags: ["折叠屏", "量产", "官方回应", "数码评测"],
    heat: 64200,
    views: 25400,
    comments: 596,
    author: "数码对比局",
    time: "20小时前",
    content: [
      "工程机在正式开售前流出给评测博主，本来是很常见的预热流程，但这次几位博主在测试中发现了一个共同问题：在低温环境下，折叠铰链的开合阻力比常温状态明显增大，部分样机甚至出现了轻微的异响。",
      "问题被集中整理成视频后，讨论迅速升温。有用户翻出了上一代产品在同样温度条件下的测试数据，对比之下差异确实存在，这让「是不是量产工艺问题」成为最集中的疑问。",
      "品牌方在当晚发布了一份说明，表示「低温环境下铰链阻力变化属于材料正常物理特性，已通过长期可靠性测试」，同时强调正式量产版本对铰链结构做了优化。",
      "对于一个定价不低的新品类来说，消费者的敏感度本来就高。这份说明能否说服人，可能要看接下来几周零售机的实际反馈。",
    ],
    points: [
      "低温环境下铰链开合阻力明显增大，部分样机有异响",
      "与上一代产品在同温度下数据形成对比",
      "官方称属材料特性并强调量产版本已优化",
    ],
  },
  {
    id: "wanghong-canting-paigzu",
    title: "网红餐厅排队三小时，尝鲜食客的评价两极分化",
    category: "live",
    categoryName: "网红直播",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20night%20restaurant%20entrance%20with%20a%20warm%20neon%20sign%20and%20blurred%20city%20lights%2C%20people%20waiting%20in%20line%2C%20moody%20cinematic%20photograph%2C%20amber%20glow%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-08&orientation=landscape",
    summary:
      "因为一段短视频而爆火的这家小店，最近排队时长动辄三小时。真正吃上的人里，评价却出现了明显的两极化。",
    tags: ["网红店", "排队", "探店", "评价"],
    heat: 58700,
    views: 22100,
    comments: 512,
    author: "探店实录",
    time: "1天前",
    content: [
      "这家原本只有六张桌子的小店，因为一条探店短视频在两周内爆火。工作日下午四点半，门口已经排起了三十多人的队伍，取号系统显示的预计等待时间是三小时二十分钟。",
      "真正吃到的人给出的评价相当分裂。一部分人认为主推菜品的调味确实有辨识度，值得专程来一趟；另一部分人则觉得，等三小时换来的是一顿普通水平的饭，性价比被严重稀释了。",
      "店主在接受采访时表示，后厨产能有限，短期内不会扩大规模，也不会做限流之外的调整。这种「不迎合流量」的态度本身也成了讨论的一部分。",
      "对围观者来说，这个瓜的真正价值可能不在于饭好不好吃，而在于「值不值得为网红标签付出三小时」这个问题，每个人都有自己的答案。",
    ],
    points: [
      "爆火源于一条短视频，两周内客流翻十倍",
      "评价围绕「味道是否配得上等待时长」两极分化",
      "店主明确表示短期不扩产、不迎合流量",
    ],
  },
  {
    id: "zhenrenxiu-jianji-zhengyi",
    title: "真人秀剪辑争议升级，粉丝要求公开完整素材",
    category: "variety",
    categoryName: "综艺现场",
    cover:
      "https://readdy.ai/api/search-image?query=video%20editing%20timeline%20glowing%20on%20a%20dark%20monitor%20in%20a%20dim%20studio%2C%20warm%20desk%20lamp%20glow%2C%20moody%20cinematic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-09&orientation=landscape",
    summary:
      "最新一期播出后，有观众逐帧比对预告与正片，认为某位嘉宾的镜头被大量删减，节目组的剪辑逻辑受到质疑。",
    tags: ["真人秀", "剪辑", "镜头分配", "节目组"],
    heat: 55300,
    views: 20800,
    comments: 487,
    author: "剪辑字幕组",
    time: "1天前",
    content: [
      "这档真人秀的预告片里，某位嘉宾有一段情绪爆发的片段，被剪进预告的重点位置。但正片播出后，这段内容不仅没有出现，该嘉宾整期的有效镜头也明显少于其他成员。",
      "有观众把预告与正片做了逐帧比对，整理出一份「消失的镜头清单」，在评论区引发大量转发。诉求也很直接：要么公开完整素材，要么给出删减理由。",
      "节目组目前的回应是「正片剪辑以整体节奏和叙事逻辑为准，不存在针对个人的删减」。这句话在技术上无可指摘，但在情绪层面几乎没有起到安抚作用。",
      "这类争议其实每年都会出现几次。它真正的价值，也许是让观众开始意识到：我们看到的「真实」，本身就是被剪辑过的产物。",
    ],
    points: [
      "预告重点片段在正片中完全消失",
      "观众逐帧比对整理出「消失镜头清单」",
      "节目组称剪辑以整体叙事为准，否认针对个人",
    ],
  },
  {
    id: "laopai-yuedui-chongzu",
    title: "老牌乐队宣布重组，巡演门票三分钟售罄",
    category: "music",
    categoryName: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20electric%20guitar%20leaning%20against%20a%20dark%20stage%20with%20a%20single%20warm%20spotlight%2C%20dusty%20haze%2C%20moody%20cinematic%20photograph%2C%20amber%20glow%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=yc-topic-10&orientation=landscape",
    summary:
      "解散八年后，这支老牌乐队突然宣布重组并开启巡演。首站门票开售三分钟售罄，二手票价已经翻了数倍。",
    tags: ["乐队重组", "巡演", "门票", "情怀"],
    heat: 61100,
    views: 23900,
    comments: 553,
    author: "乐迷电台",
    time: "2天前",
    content: [
      "解散八年后，这支曾经在独立音乐圈留下过几张经典专辑的乐队，突然在社交平台发布了重组消息。没有预热，没有倒计时，只有一张模糊的排练室照片和一行日期。",
      "首站门票开售三分钟售罄，多个城市的票价在二手平台上翻了数倍。对老乐迷来说，这不是一场普通的演出，而是一次被推迟了八年的告别补课。",
      "也有理性的声音提出疑问：重组后的新作品能不能撑起情怀之外的价值？毕竟乐队的核心成员这些年各自发展，音乐方向早已不同。",
      "乐队在接受采访时只说了一句话：「先见面，再谈以后。」这句话被乐迷剪进了各种二创视频里，成为这次重组最有传播度的一句文案。",
    ],
    points: [
      "解散八年后无预热突然官宣重组",
      "首站门票三分钟售罄，二手票价翻数倍",
      "「先见面，再谈以后」成为传播金句",
    ],
  },
];